/**
 * Detects if the current domain is the Indian domain (.in).
 */
export const isIndiaDomain = () => {
  if (typeof window !== "undefined") {
    return window.location.hostname.endsWith(".in");
  }
  return false;
};

/**
 * Formats a price (base INR) into either INR or USD depending on the domain.
 * @param {number} inrAmount - The price in Indian Rupees.
 * @returns {string} Formatted price string.
 */
export const formatPrice = (inrAmount) => {
  if (!inrAmount) return "";

  if (isIndiaDomain()) {
    return `₹${inrAmount.toLocaleString("en-IN")}`;
  }

  // Conversion rate: ~83.5 INR = 1 USD
  const rawUsd = inrAmount / 83.5;
  // For per-km rates (under 100 INR), show decimals. Otherwise round up.
  const usdAmount = inrAmount < 100 ? rawUsd.toFixed(2) : Math.ceil(rawUsd);
  return `$${usdAmount}`;
};
